enum StatusAsync {
    IDLE = "IDLE",
    PENDING = "PENDING",
    RESOLVED = "RESOLVED",
    REJECTED = "REJECTED",
  }
  
  export default StatusAsync;
  